const view = (name: string, outputs: readonly { type: string; name?: string }[], inputs: readonly { type: string; name: string }[] = []) =>
  ({ type: 'function', name, stateMutability: 'view', inputs, outputs }) as const;

export const cometAbi = [
  view('totalSupply', [{ type: 'uint256' }]),
  view('balanceOf', [{ type: 'uint256' }], [{ name: 'account', type: 'address' }]),
  view('totalBorrow', [{ type: 'uint256' }]),
  view('getUtilization', [{ type: 'uint256' }]),
  view('getSupplyRate', [{ type: 'uint64' }], [{ name: 'utilization', type: 'uint256' }]),
  view('supplyKink', [{ type: 'uint256' }]),
  view('getReserves', [{ type: 'int256' }]),
  view('targetReserves', [{ type: 'uint256' }]),
  view('isSupplyPaused', [{ type: 'bool' }]),
  view('isWithdrawPaused', [{ type: 'bool' }]),
  view('isAbsorbPaused', [{ type: 'bool' }]),
  view('numAssets', [{ type: 'uint8' }]),
  view('governor', [{ type: 'address' }]),
  view('pauseGuardian', [{ type: 'address' }]),
] as const;
